import { SVGProps } from 'react'

export const ChevronDown = ({
  size = 24,
  className,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.05356 7L12 14.9464L19.9464 7L21 8.05356L12 17.0536L3 8.05356L4.05356 7Z"
      fill="currentColor"
    />
  </svg>
)
